import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

const AdminRoute: React.FC = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  
  return user.role === 'admin' ? <Outlet /> : <Navigate to="/dashboard" replace />
}

export default AdminRoute